import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { alpha } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { BackIcon } from 'assets/icons';
import type { FC } from 'react';
import { GLASS_BACKGROUND, GLASS_BLUR, NAVY, RADIUS_CARD, SHADOW } from 'styles/tokens';

interface BusinessUnitConfigHeaderProps {
  onBack: () => void;
}

const BusinessUnitConfigHeader: FC<BusinessUnitConfigHeaderProps> = ({ onBack }) => (
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      mb: 3,
      px: { xs: 1.5, lg: 2 },
      py: 1.25,
      borderRadius: RADIUS_CARD,
      backgroundColor: GLASS_BACKGROUND,
      backdropFilter: GLASS_BLUR,
      WebkitBackdropFilter: GLASS_BLUR,
      boxShadow: SHADOW,
    }}
  >
    <Tooltip title="Volver" arrow>
      <IconButton
        onClick={onBack}
        size="medium"
        aria-label="Volver"
        sx={{
          color: alpha(NAVY, 0.7),
          '&:hover': { color: NAVY, backgroundColor: alpha(NAVY, 0.06) },
        }}
      >
        <BackIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </Box>
);

export default BusinessUnitConfigHeader;
